<template>
  <section
    :class="['activity-share-header', type]"
    :style="{
      backgroundImage: `url(${headerBanner})`,
    }"
  >
    <!-- <div :class="['activity-desc-wrapper', type]">
      <div class="title">
        <p class="title1">
          <i18n path="fission.activity-description" tag="span">
            <span place="amount" class="awards">{{ number }}</span>
          </i18n>
        </p>
      </div>
      <div class="desc">15 March - 15 April 2022</div>
    </div> -->
    <div
      :class="[
        'header-basic-wrapper',
        fissionGame,
        type === 'page' ? 'hasLogo' : 'noLogo',
      ]"
    >
      <div v-show="type === 'page'" class="logo-wrapper">
        <!--        <img
          class="toplupe-logo"
          v-lazy="require(`@/assets/images/common/logo.png`)"
          alt="logo"
          @click="back"
        />-->
        <img
          class="toplupe-logo"
          v-lazy="require(`@/assets/images/common/toplupe-logo.png`)"
          alt="logo"
          @click="back"
        />
        <!-- <img
          class="game-logo"
          v-lazy="require(`@/assets/images/activities/fission/mlbb.png`)"
          alt="logo"
        /> -->
      </div>
      <div class="back-bar" @click="click">
        <span class="text">{{ $t('fission.activity-rules') }}</span>
        <MBIcon :size="35" name="icon-arrow" color="#fff" />
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { tryToNative } from '@/utils/native'
  import MBIcon from '@/components/MBIcon'
  export default {
    components: {
      MBIcon,
    },
    props: {
      headerBanner: {
        type: String,
        default: require(`@/assets/images/activities/fission/banner-new.png`),
      },
      type: {
        type: String,
        default: 'page', // page: 页面, popup: 弹框
      },
      number: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      ...mapState(['region', 'fissionGame']),
    },
    methods: {
      click() {
        this.$emit('to-rules')
        this.$router_push({
          path: '/fission-rules',
          query: {
            ...this.$route.query,
            fissionGame: this.fissionGame,
          },
        })
      },
      back() {
        tryToNative({
          url: 'home',
          params: null,
        }).catch(() => {
          this.$router_push({
            path: '/',
            query: {
              ...this.$route.query,
            },
          })
        })
      },
    },
  }
</script>

<style lang="scss" src="./index.scss"></style>
